import React, { useState } from 'react';
import {
    Box,
    Button,
    IconButton,
    TextField,
    Typography,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import InputBox from '../../atomic/inputbox/InputBox';
import { containsUnsafeScriptContent } from '../../utils/regexValidation';

export default function IngredientsInput(props) {

    const { ingredients, setIngredients } = props
    const [errors, setErrors] = useState({});

    const isValidInput = (value) => {
        const trimmed = value.trim();
        return trimmed.length > 0 && !containsUnsafeScriptContent(trimmed);
    };

    const handleInputChange = (index, value) => {
        const updated = [...ingredients];
        updated[index] = value;
        setIngredients(updated);

        const validationErrors = { ...errors };
        if (!isValidInput(value)) {
            validationErrors[index] = 'Script or unsafe content is not allowed.';
        } else {
            delete validationErrors[index];
        }
        setErrors(validationErrors);
    };

    const handleAdd = () => {
        setIngredients([...ingredients, '']);
    };

    const handleRemove = (index) => {
        const updated = ingredients.filter((_, i) => i !== index);
        const updatedErrors = { ...errors };
        delete updatedErrors[index];
        setIngredients(updated);
        setErrors(updatedErrors);
    };

    const sanitizedIngredients = ingredients
        .map((item) => item.trim())
        .filter((item) => isValidInput(item));

    return (
        <Box sx={{ p: 0, maxWidth: 600 }}>
            <div style={{ fontSize: '20px', fontFamily: 'Inter Medium', margin: '0px 0px 10px 0px' }}> Ingredients </div>

            <div style={{ width: '260px', fontSize: 'Inter Regular', fontSize: '12px', marginBottom: '20px' }}>
                Help customers know what's inside your product.
            </div>

            {ingredients.map((ingredient, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <TextField
                        fullWidth
                        label={`Ingredient ${index + 1}`}
                        value={ingredient}
                        onChange={(e) => handleInputChange(index, e.target.value)}
                        error={!!errors[index]}
                        helperText={errors[index]}
                        variant="outlined"
                        size="small"
                        InputLabelProps={{
                            sx: {
                                color: 'lightgray',
                                '&.Mui-focused': {
                                    color: 'rgb(255, 123, 41)',
                                },
                            },
                        }}
                        InputProps={{
                            sx: {
                                fontSize: '14px', // Set font size cleanly
                            },
                        }}
                        sx={{
                            width: '220px',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 1,
                                backgroundColor: '#fff',
                                '& fieldset': {
                                    // borderColor: '#ccc',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'rgb(24, 20, 54)',
                                    // backgroundColor: '#f9f9f9',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'rgb(24, 20, 54)',
                                    // boxShadow: '0 0 0 2px rgba(24, 20, 54, 0.2)',
                                },
                            },
                        }}
                    />


                    {ingredients.length > 1 && (
                        <IconButton
                            onClick={() => handleRemove(index)}
                            sx={{ ml: 1 }}
                            color="error"
                        >
                            <Delete />
                        </IconButton>
                    )}
                </Box>
            ))}

            <Button
                variant="contained"
                startIcon={<Add />}
                onClick={handleAdd}
                sx={{
                    mt: 1,
                    color: 'rgb(24, 20, 54)',
                    backgroundColor: '#EAEFEF',
                    '&:hover': {
                        backgroundColor: 'rgb(24, 20, 54)', // hover background
                        color: 'white', // optional: text color on hover
                    },
                }}
            >
                Add Ingredient
            </Button>

            {/* <Box mt={3}>
                <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                    Final sanitized ingredients array:
                </Typography>
                <Typography variant="body1">
                    {JSON.stringify(sanitizedIngredients)}
                </Typography>
            </Box> */}
        </Box>
    );
}